<template>
	<div class="four-oh-four">
		<div class="container">
           <div class="quote-requested-success__title">{{maContent.ma9_1_1}}</div>
			<div class="quote-requested-success__subhead">
				{{maContent.ma9_1_2}}
			</div>
			<div>
				<img src="@/assets/images/img__payment-success.png" style="max-width:110px"><br><br><br><br>
			</div>
			<a v-bind:href="maContent.ma9_1_3_2">
				<button class="btn btn-small primary">{{maContent.ma9_1_3_1}}</button>
			</a>
        </div>
	</div>
</template>

<script>

export default {
	computed : {
		maContent(){
				return this.$store.getters.getBuildData;
				},
		},
}
</script>



// WEBPACK FOOTER //
// src/components/pages/FourOhFourPage.vue